export default __webpack_public_path__ + "static/media/Multi-party Compensation.f7c40ff2.png";